// extracted by mini-css-extract-plugin
module.exports = {"bb-resources-download":"bb-resources-download__gotnL","resources":"resources__vt_19"};